<div class="modal-body">
	<button type="button" class="btn btn-modal-close" (click)="activeModal.close()">
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7.29297 8L0.646484 14.6465L1.35359 15.3536L8.00008 8.70711L14.6466 15.3536L15.3537 14.6465L8.70718 8L15.3536 1.35359L14.6465 0.646484L8.00008 7.29289L1.35367 0.646484L0.646561 1.35359L7.29297 8Z"
				fill="currentColor" />
		</svg>
	</button>

	<a href="https://www.ecsomag.hu/glsnyeremenyjatek" target="_blank" style="display: block; aspect-ratio: 8 / 6; max-width: 800px" (click)="activeModal.close()">
		<img src="/assets/img/content/promo/202309-gls25-promo.jpg" width="100%" alt="GLS 25. SZÜLETÉSNAPI NYEREMÉNYIÂTÉK" />
	</a>
</div>
